import React, { Component } from 'react';
import { Col, DatePicker, Row, Select, Table } from 'antd';
import { withRouter } from 'react-router-dom';
import numeral from 'numeral';
import _ from 'lodash';

import * as consultantController from '../../../../../../services/api/consultant';
import * as programmeController from '../../../../../../services/api/programme';
import * as channelController from '../../../../../../services/api/channel';
import './ConsultantRanking.scss';

const { Option } = Select;
const { RangePicker } = DatePicker;

export class ConsultantRanking extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            programmes: [],
            selectedProgrammes: [],
            channels: [],
            selectedChannels: [],
            selectedDateRanges: [],
            enrollmentRankings: [],
            performanceRankings: []
        }
    }

    fetchProgrammes() {
        this.setState({ isLoading: true });

        programmeController.getProgrammes({ isSimple: true })
            .then((res) => res.json())
            .then((json) => this.setState({ programmes: json, isLoading: false }))
    }

    fetchChannels() {
        this.setState({ isLoading: true });

        channelController.getChannels({ isSimple: true })
            .then((res) => res.json())
            .then((json) => this.setState({ channels: json, isLoading: false }))
    }

    fetchRankings() {
        const { selectedProgrammes, selectedChannels, selectedDateRanges } = this.state;

        this.setState({ isLoading: true });

        consultantController.getConsultantRanking({
                programme_ids: selectedProgrammes,
                channel_ids: selectedChannels,
                since: selectedDateRanges[0] && selectedDateRanges[0].startOf('day').toISOString(),
                until: selectedDateRanges[1] && selectedDateRanges[1].endOf('day').toISOString()
            })
            .then((res) => res.json())
            .then((json) => {
                let enrollmentRankings = [],
                    performanceRankings = [];
                _.forEach(json, (record) => {
                    const { id, name, number_of_enrolled_lead, avg_conversion_time } = record;
                    if (parseInt(number_of_enrolled_lead, 10) !== 0)
                        performanceRankings.push({ id, name, avg_conversion_time: parseFloat(avg_conversion_time) });
                    enrollmentRankings.push({ id, name, number_of_enrolled_lead: parseInt(number_of_enrolled_lead, 10) });
                })

                enrollmentRankings = _.orderBy(enrollmentRankings, ['number_of_enrolled_lead', 'id'], ['desc', 'asc']);
                performanceRankings = _.orderBy(performanceRankings, ['avg_conversion_time', 'id'], ['asc', 'asc']);

                this.setState({ enrollmentRankings, performanceRankings, isLoading: false });
            })
    }

    componentDidMount() {
        this.fetchProgrammes();
        this.fetchChannels();
        this.fetchRankings();
    }

    componentDidUpdate(prevProps, prevState) {
        const { selectedProgrammes, selectedChannels, selectedDateRanges } = this.state;

        if (!_.isEqual(selectedProgrammes, prevState.selectedProgrammes) ||
            !_.isEqual(selectedChannels, prevState.selectedChannels) ||
            !_.isEqual(selectedDateRanges, prevState.selectedDateRanges))
            this.fetchRankings();
    }

    render() {
        const { history } = this.props;
        const { programmes, selectedProgrammes, channels, selectedChannels, selectedDateRanges, enrollmentRankings, performanceRankings } = this.state;

        const programmeOptions = _.map(programmes, (programme) => <Option key={programme.id} value={programme.id}>{programme.name}</Option>);
        const channelOptions = _.map(channels, (channel) => <Option key={channel.id} value={channel.id}>{channel.name}</Option>);

        const enrollmentColumns = [{
            title: '',
            dataIndex: 'ranking',
            key: 'ranking',
            align: 'center',
            render: (text, record, index) => index + 1
        }, {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            align: 'center',
        }, {
            title: 'Number of Enrollment',
            dataIndex: 'number_of_enrolled_lead',
            key: 'number_of_enrolled_lead',
            align: 'center',
        }];
        const performanceColumns = [{
            title: '',
            dataIndex: 'ranking',
            key: 'ranking',
            align: 'center',
            render: (text, record, index) => index + 1
        }, {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            align: 'center',
        }, {
            title: 'Avg. Conversion Time',
            dataIndex: 'avg_conversion_time',
            key: 'avg_conversion_time',
            align: 'center',
            render: (text, record) => `${numeral(text).format('0.[00]')} days`
        }];

        return (
            <div className="ConsultantRanking">
                <Row className="option-bar">
                    <Col span={24}>
                        <div className="query-option">
                            <label>Programme(s): </label>
                            <Select
                                mode="multiple"
                                style={{ width: 200 }}
                                placeholder="(All)"
                                value={selectedProgrammes}
                                onChange={(value) => this.setState({ selectedProgrammes: value} )}
                            >
                                {programmeOptions}
                            </Select>
                        </div>
                        {" "}
                        <div className="query-option">
                            <label>Channel(s): </label>
                            <Select
                                mode="multiple"
                                style={{ width: 200 }}
                                placeholder="(All)"
                                value={selectedChannels}
                                onChange={(value) => this.setState({ selectedChannels: value} )}
                            >
                                {channelOptions}
                            </Select>
                        </div>
                        {" "}
                        <div className="query-option">
                            <label>Date Range: </label>
                            <RangePicker
                                value={selectedDateRanges}
                                onChange={(dates, dateStrings) => this.setState({ selectedDateRanges: dates })}
                            />
                        </div>
                    </Col>
                </Row>
            	<Row>
                	<Col lg={12} xs={24}>
                		<div className="ranking-section">
		                	<h3>Perfomance Ranking (Number of Enrollment)</h3>
	                		<div className="ranking-table">
		                		<Table
				                    rowKey="id"
				                    columns={enrollmentColumns}
				                    dataSource={enrollmentRankings}
				                    pagination={false}
                                    onRow={(row) => ({
                                        onClick: () => history.push(`/dashboard/admin/consultant/${row.id}`)
                                    })}
		                		/>
	                		</div>
                		</div>
                	</Col>
                	<Col lg={12} xs={24}>
                		<div className="ranking-section">
		                	<h3>Perfomance Ranking (Avg. Conversion time)</h3>
	                		<div className="ranking-table">
		                		<Table
				                    rowKey="id"
				                    columns={performanceColumns}
				                    dataSource={performanceRankings}
				                    pagination={false}
                                    onRow={(row) => ({
                                        onClick: () => history.push(`/dashboard/admin/consultant/${row.id}`)
                                    })}
		                		/>
	                		</div>
                		</div>
                	</Col>
            	</Row>
            </div>
        );
    }
}

export default withRouter(ConsultantRanking);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ConsultantPage/scenes/ConsultantRanking/ConsultantRanking.js